import classNames from 'classnames';
import queryString from 'query-string';
import { useState } from 'react';

import { CURRENT_TIMEZONE, formatDate, formatDateRange } from 'my-core/date-utils';
import { studySessionCalendarLinkClicked } from 'my-core/gtm-events';

import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

import { faCalendarAlt, faChevronDown, faClock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const dateDetailsCss = ({ palette, shape, spacing, transitions }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: spacing(1),

  '.SSCD-dateDetailsDates': {
    display: 'flex',
    alignItems: 'center',
  },
  '.SSCD-dateDetailsItem': {
    marginRight: spacing(1),
    '& > svg': {
      color: palette.text.secondary,
      marginRight: spacing(0.5),
    },
  },
  '.SSCD-expandIcon': {
    transition: transitions.create('transform'),
    '&.SSCD-expandIcon_open': { transform: 'rotate(180deg)' },
  },

  '.SSCD-dateDetailsExpanded': {
    borderRadius: shape.borderRadiusSm,
    background: palette.background.paper,
    padding: spacing(2, 3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

const CALENDAR_FORMATS = [
  {
    label: 'Google',
    fnName: 'google',
  },
  {
    label: 'iCal',
    fnName: 'ical',
  },
  {
    label: 'Outlook',
    fnName: 'outlook',
  },
  {
    label: 'Yahoo',
    fnName: 'yahoo',
  },
];

export default function StudySessionCheckoutDate(props) {
  const { date, studySession } = props;
  const [detailsOpen, setDetailsOpen] = useState(false);

  function addToCalendar(calendar, date) {
    studySessionCalendarLinkClicked(studySession, calendar);
    const link = `/api/v1/study_sessions/${studySession.id}/calendar?${queryString.stringify({
      date_id: date.id,
      format: calendar,
      course_id: studySession.course?.id,
    })}`;
    window.open(link, '_blank');
  }
  const startTime = new Date(date.start_time);
  const isUpcoming = startTime > new Date();

  return (
    <>
      <div css={dateDetailsCss}>
        <div className="SSCD-dateDetailsDates">
          <Typography className="SSCD-dateDetailsItem" variant="body2">
            <FontAwesomeIcon fixedWidth icon={faCalendarAlt} />{' '}
            {`${
              studySession.disable_zoom ?
                isUpcoming ? 'Releases: '
                : 'Released: '
              : ''
            }${formatDate(startTime, 'upcomingDateAndDay')}`}
          </Typography>
          <Typography className="SSCD-dateDetailsItem" variant="body2">
            <FontAwesomeIcon fixedWidth icon={faClock} />
            {`${studySession.disable_zoom ? formatDate(startTime, 'time') : formatDateRange(startTime, date.end_time, 'time')} ${CURRENT_TIMEZONE}`}
          </Typography>
        </div>
        {isUpcoming && (
          <Button
            endIcon={
              <FontAwesomeIcon
                className={classNames('SSCD-expandIcon', { 'SSCD-expandIcon_open': detailsOpen })}
                icon={faChevronDown}
              />
            }
            onClick={() => setDetailsOpen(!detailsOpen)}
            size="small"
          >
            Add to Calendar
          </Button>
        )}
      </div>
      <Collapse in={detailsOpen}>
        <div className="SSCD-dateDetailsExpanded">
          {CALENDAR_FORMATS.map(({ fnName, label }, idx) => (
            <Button
              key={idx}
              onClick={e => {
                e.preventDefault();
                addToCalendar(fnName, date);
              }}
              variant="outlined"
            >
              {label}
            </Button>
          ))}
        </div>
      </Collapse>
    </>
  );
}
